angular.module('rjmNg.api').factory("CalculationDefinition", [
  'BaseDefinition'
  'encodedLetterString'
  'dataWarehouse'
  (BaseDefinition, encodedLetterString, dataWarehouse) ->

    class CalculationDefinition extends BaseDefinition

      @definition: 'calculation'
      @category: 'sameTable'
      @arg: 'column'
      @subtypes: [
          symbol: 'CALCULATION'
          description: 'Use SQL to transform data'
          typeFilter: [
          ]
      ]
      @filtersSupported: false

      @fromColumn: (structure, column) ->
        field = super structure, column, @definition
        field.properties =
          janino_syntax: column.properties.janino_syntax
          source_column_ids: @getColumnInputs(column.properties.source_column_ids)
        field.datatype = column.old_data_type
        return field

      @toColumn: (structure, table, field) ->
        result = super structure, table, field
        result.field_type = @getFieldType(field.datatype)
        result.old_data_type = field.datatype
        angular.extend(result.properties,
          derivative_type: 'calculation'
          source_column_ids: @getSourceColumnMap(field.properties.source_column_ids)
          syntax: ''
          janino_syntax: field.properties.janino_syntax
          janino_mode: 'script'
        )

        return result

      @getSourceColumnMap: (inputs) ->
        inputMap = {}
        for input in inputs
          inputMap[encodedLetterString.indexToAlpha(input.inputId, false)] = input.column
        return inputMap

      @getColumnInputs: (map) ->
        columnInputs = []
        for index, item of map
          input =
            inputId: encodedLetterString.alphaToIndex(index)
            column: item
          columnInputs.push(input)
        # sort by inputId asc
        # this is important because we need the index to match the inputId
        columnInputs.sort (a,b) -> a.inputId - b.inputId
        return columnInputs

      @getFieldType: (datatype) ->
        FIELD_TYPES = dataWarehouse.FIELD_TYPES
        DATA_TYPES = dataWarehouse.DATA_TYPES
        switch datatype
          when DATA_TYPES.DATETIME.id then FIELD_TYPES.DATETIME.id
          when DATA_TYPES.DECIMAL_10_2.id then FIELD_TYPES.VALUE_CURRENCY.id
          when DATA_TYPES.VARCHAR_255.id then FIELD_TYPES.DESCRIPTION.id
          when DATA_TYPES.BIGINT.id then FIELD_TYPES.VALUE_GENERAL.id
          else FIELD_TYPES.FLAG.id

      @validateField: (column) ->
        super?.validateField(column)
        if not column.properties.source_column_ids? or column.properties.source_column_ids.length < 1
          throw "You need to add at least one input to calculation columns."

        if not column.properties.janino_syntax? \
          or column.properties.janino_syntax.replace(/\s+/g, '').length is 0
            throw "The calculation cannot be empty."

        if not column.datatype?
          throw "You need to set the calculation return datatype."
  ]
)
